import axiosBase from "api/axiosBase";

export const apiLoadContacts = () => axiosBase.get("contact/");

export const apiLoadContactMain = () =>
  axiosBase.get("block/page/main?parent=contactsMain");

